module.exports = __webpack_public_path__ + "img/React-FoodOrderApp-desktop.1ee9aecf.jpg";